<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="纪念馆升级"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-tabs
        sticky
        animated
        offset-top="46"
        title-active-color="#fff"
        title-inactive-color="#f2f2f2"
        background="#24a378"
        color="#fff"
        :border="false"
      >
        <van-tab title="豪华">
          <div class="upgrade-table">
            <div class="thead">
              <div class="hd hlight">在线充值</div>
              <div>单位/孝爱币</div>
            </div>
            <div class="tcell">
              <div class="label">价格</div>
              <div class="tbody">199</div>
            </div>
            <div class="tcell">
              <div class="label">年费</div>
              <div class="tbody">39</div>
            </div>
            <div class="tcell">
              <div class="label">储存空间</div>
              <div class="tbody">1G</div>
            </div>
            <div class="tcell">
              <div class="hlight tequanlabel">特权</div>
              <div class="tdetails">
                <!-- 可上传30首音乐也可在系统音乐库中选择，可连续选择10首做为背影音乐。 -->
                1、PC端与手机端各类祭品：8折优惠 <br />
                2、PC端与手机端纪念馆模板、墓园模板、纪念堂模板：8折优惠 <br />
                3、PC端可上传3首音乐也可在系统音乐库中选择，可连续选择3首做为背影音乐。<br />
                4、PC端与手机端天堂信箱可上传图片<br />
                5、PC端纪念馆编号：8折优惠<br />
                6、PC端与手机端显示身份徽章
              </div>
            </div>
            <div class="tcell">
              账户余额:
              {{ viewMember != null ? viewMember.Member.HasCoin : 1000 }}孝爱币
            </div>
          </div>
          <div class="btn-area">
            <van-button @click="onLevelUp(2)" class="mybtn" block
              >我要升级</van-button
            >
          </div>
        </van-tab>
        <van-tab title="尊贵">
          <div class="upgrade-table">
            <div class="thead">
              <div class="hd hlight">在线充值</div>
              <div>单位/孝爱币</div>
            </div>
            <div class="tcell">
              <div class="label">价格</div>
              <div class="tbody">399</div>
            </div>
            <div class="tcell">
              <div class="label">年费</div>
              <div class="tbody">69</div>
            </div>
            <div class="tcell">
              <div class="label">储存空间</div>
              <div class="tbody">2G</div>
            </div>
            <div class="tcell">
              <div class="hlight tequanlabel">特权</div>
              <div class="tdetails">
                <!-- 可上传30首音乐也可在系统音乐库中选择，可连续选择10首做为背影音乐。 -->
                1、PC端与手机端各类祭品：6折优惠 <br />
                2、PC端与手机端纪念馆模板、墓园模板、纪念堂模板：6折优惠 <br />
                3、PC端可上传10首音乐也可在系统音乐库中选择，可连续选择10首做为背影音乐。<br />
                4、PC端与手机端天堂信箱可上传图片、音频、视频<br />
                5、PC端纪念馆编号：6折优惠<br />
                6、PC端与手机端显示身份徽章
              </div>
            </div>
            <div class="tcell">
              账户余额:
              {{ viewMember != null ? viewMember.Member.HasCoin : 1000 }}孝爱币
            </div>
          </div>
          <div class="btn-area">
            <van-button @click="onLevelUp(3)" class="mybtn" block>我要升级</van-button>
          </div>
        </van-tab>
        <van-tab title="钻石">
          <div class="upgrade-table">
            <div class="thead">
              <div class="hd hlight">在线充值</div>
              <div>单位/孝爱币</div>
            </div>
            <div class="tcell">
              <div class="label">价格</div>
              <div class="tbody">699</div>
            </div>
            <div class="tcell">
              <div class="label">年费</div>
              <div class="tbody">99</div>
            </div>
            <div class="tcell">
              <div class="label">储存空间</div>
              <div class="tbody">5G</div>
            </div>
            <div class="tcell">
              <div class="hlight tequanlabel">特权</div>
              <div class="tdetails">
                <!-- 可上传30首音乐也可在系统音乐库中选择，可连续选择10首做为背影音乐。 -->
                1、PC端与手机端各类祭品：5折优惠 <br />
                2、PC端与手机端纪念馆模板、墓园模板、纪念堂模板：3折优惠 <br />
                3、PC端可上传30首音乐也可在系统音乐库中选择，可连续选择30首做为背影音乐。
                <br />
                4、PC端与手机端天堂信箱可上传图片、音频、视频 <br />
                5、PC端纪念馆编号：4折优惠 <br />
                6、PC端与手机端显示身份徽章
              </div>
            </div>
            <div class="tcell">
              账户余额:
              {{ viewMember != null ? viewMember.Member.HasCoin : 1000 }}孝爱币
            </div>
          </div>
          <div class="btn-area">
            <van-button @click="onLevelUp(4)" class="mybtn" block>我要升级</van-button>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {
      id: "",
    };
  },
  computed: {
    ...mapGetters(["currentToken", "viewMember"]),
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      var params = {
        type: "GetMemberIndex",
      };
      that.$store.dispatch(params);
    },
    onLevelUp(level) {
      var that = this;
      Dialog.confirm({
        title: "系统提示",
        message: "确定升级或者续费此纪念馆！",
      })
        .then(() => {
          that.$store
            .dispatch({
              type: "UpgradeMemorialHallVue",
              id: that.id,
              level: level,
            })
            .then((res) => {
              // console.log(res,"UpgradeMemorialHallVue");
              Toast(res.Message);
              if (res.IsSuccess) {
                setTimeout(() => {
                  // that.$router.replace("/MemorialHall?id="+that.id);
                  that.$router.go(-2);
                }, 1000);
              }

            });
        })
        .catch(() => {});
    },
  },
  created() {
    var that = this;
    that.id = this.$route.query.id;
    that.init();
  },
};
</script>

<style scoped>
.upgrade-table {
  padding: 30px 20px;
  font-size: 14px;
  color: #333;
}
.upgrade-table .thead {
  font-size: 12px;
  color: #888;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.upgrade-table .tcell {
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 14px 0 6px;
}
.upgrade-table .label {
  flex: 1;
  padding: 0 10px;
}
.upgrade-table .tbody {
  flex: 1;
  text-align: right;
  padding: 0 10px;
}
.upgrade-table .tequanlabel {
  padding: 0 10px;
}
.upgrade-table .tdetails {
  flex: 1;
  text-align: left;
  padding: 0 10px;
}
</style>
